export function initiateOAuth(provider) {
  const providerMap = { google: 'google_oauth2', facebook: 'facebook' }
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = `/users/auth/${providerMap[provider]}`

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
  if (csrfToken) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = 'authenticity_token'
    input.value = csrfToken
    form.append(input)
  }

  const localeInput = document.createElement('input')
  localeInput.type = 'hidden'
  localeInput.name = 'locale'
  localeInput.value = localStorage.getItem('locale') || 'ro'
  form.append(localeInput)

  document.body.append(form)
  form.submit()
}
